import poolieForm from './poolieForm';
import conditionalLogic from './conditionalLogic';
import inputNumberMask from './inputNumberMask';
import inputDateTime from './inputDateTime';
import fileUpload from './fileUpload';
import autoSubmitForm from './autoSubmitForm';

const recaptchFormObserver = {
    init() {
        window.addEventListener('recaptchaCookieLoaded', () => {
            const recaptchaForm = document.querySelector('.js-recaptcha-form');
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'childList') {
                        poolieForm.init();
                        conditionalLogic.init();
                        inputNumberMask.init();
                        inputDateTime.init();
                        fileUpload.init();
                        autoSubmitForm.init();
                    }
                });
            });

            observer.observe(recaptchaForm, {childList: true});
        });
    },
};

export default recaptchFormObserver;
